/**
 * @generated SignedSource<<eb206b39f4606a923386fc95e48c9434>>
 * @relayHash dc5cd8c4836d8ca5960022ace78a6e71
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbf088afb9ae6d01f1aa760e85d38305faca85008ae932a4b4ed1877c4605e35

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reportCategoriesQuery$variables = {
  boardId: string;
  cloudId: string;
  isBoardContext: boolean;
  projectKey: string;
};
export type reportCategoriesQuery$data = {
  readonly jira?: {
    readonly jiraBoard: {
      readonly reportCategories?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly name: string;
            readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
          } | null | undefined;
        } | null | undefined>;
      };
    };
  };
  readonly jira_projectByIdOrKey?: {
    readonly reportCategories: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
        } | null | undefined;
      } | null | undefined>;
    };
  };
};
export type reportCategoriesQuery = {
  response: reportCategoriesQuery$data;
  variables: reportCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBoardContext"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "FragmentSpread",
  "name": "reportCategory_reportsOverviewPage"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "boardId"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "concreteType": "JiraReportCategoryConnection",
  "kind": "LinkedField",
  "name": "reportCategories",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraReportCategoryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraReportCategoryNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "concreteType": "JiraReportConnection",
              "kind": "LinkedField",
              "name": "reports",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraReportConnectionEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "JiraReport",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v8/*: any*/),
                        (v5/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "key"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "imageUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "description"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "url"
                        },
                        (v9/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            (v9/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "reportCategoriesQuery",
    "selections": [
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v4/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jira_projectByIdOrKey",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraReportCategoryConnection",
                    "kind": "LinkedField",
                    "name": "reportCategories",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraReportCategoryEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "JiraReportCategoryNode",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": (v5/*: any*/),
                                  "action": "THROW",
                                  "path": "jira_projectByIdOrKey.reportCategories.edges.node.name"
                                },
                                (v6/*: any*/)
                              ]
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira_projectByIdOrKey.reportCategories.edges"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira_projectByIdOrKey.reportCategories"
                }
              ]
            },
            "action": "THROW",
            "path": "jira_projectByIdOrKey"
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraQuery",
              "kind": "LinkedField",
              "name": "jira",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v7/*: any*/),
                    "kind": "LinkedField",
                    "name": "jiraBoard",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "concreteType": "JiraReportCategoryConnection",
                              "kind": "LinkedField",
                              "name": "reportCategories",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": {
                                    "concreteType": "JiraReportCategoryEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraReportCategoryNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "RequiredField",
                                            "field": (v5/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.jiraBoard.reportCategories.edges.node.name"
                                          },
                                          (v6/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  "action": "THROW",
                                  "path": "jira.jiraBoard.reportCategories.edges"
                                }
                              ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraBoard.reportCategories"
                          }
                        ],
                        "type": "JiraBoard"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jiraBoard"
                }
              ]
            },
            "action": "THROW",
            "path": "jira"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "reportCategoriesQuery",
    "selections": [
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v7/*: any*/),
                "kind": "LinkedField",
                "name": "jiraBoard",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "type": "JiraBoard"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bbf088afb9ae6d01f1aa760e85d38305faca85008ae932a4b4ed1877c4605e35",
    "metadata": {},
    "name": "reportCategoriesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1453022ca90770e0c346f5594ac11a43";

export default node;
